import React from 'react';
import { Button } from './ui/button';
import { X, AlertTriangle, BookOpen, CheckCircle, Save } from 'lucide-react';

const ModalDesmatricula = ({ 
  isOpen, 
  onClose, 
  curso, 
  onConfirmarDesmatricula, 
  carregandoDesmatricula = false 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-slate-900 border border-slate-700 rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto shadow-2xl">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-700">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-orange-600/20 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-orange-400" />
            </div>
            <h2 className="text-xl font-bold text-white">Confirmar Desmatrícula</h2>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-white transition-colors p-1"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Mensagem principal */}
          <div className="text-center space-y-3">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-600 to-orange-700 rounded-full flex items-center justify-center mx-auto shadow-lg">
              <AlertTriangle className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-lg font-semibold text-white">
              📚 Deseja se desmatricular deste curso?
            </h3>
            <p className="text-slate-300 text-sm leading-relaxed">
              Você está prestes a se desmatricular do curso <strong>"{curso?.titulo}"</strong>
            </p>
          </div>

          {/* Informações de progresso */}
          {curso?.progresso && (
            <div className="bg-slate-800/50 rounded-xl p-4 space-y-3">
              <div className="flex items-center justify-between">
                <h4 className="font-semibold text-white text-sm">Seu Progresso Atual</h4>
                <span className="text-blue-400 font-semibold text-sm">
                  {Math.round(curso.progresso.porcentagem)}%
                </span>
              </div>
              
              <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden">
                <div 
                  className="h-full bg-gradient-to-r from-blue-500 to-blue-400 rounded-full transition-all duration-500"
                  style={{ width: `${curso.progresso.porcentagem}%` }}
                />
              </div>
              
              <p className="text-slate-400 text-xs text-center">
                {curso.progresso.videos_concluidos || 0} de {curso.progresso.total_videos || 0} vídeos assistidos
              </p>
            </div>
          )}

          {/* Aviso sobre preservação dos dados */}
          <div className="bg-green-600/10 border border-green-600/30 rounded-xl p-4 space-y-3">
            <div className="flex items-center gap-2">
              <Save className="w-5 h-5 text-green-400 flex-shrink-0" />
              <h4 className="font-semibold text-green-400 text-sm">Seus dados estarão seguros! 🔐</h4>
            </div>
            <ul className="space-y-2 text-sm text-slate-300">
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" />
                <span>Seu progresso será <strong>mantido</strong> e estará disponível se você se matricular novamente</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" />
                <span>Todos os vídeos que você assistiu permanecerão marcados como <strong>concluídos</strong></span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" />
                <span>Você pode retomar de onde parou <strong>a qualquer momento</strong></span>
              </li>
            </ul>
          </div>

          {/* Informações do curso */}
          <div className="bg-slate-800/30 rounded-xl p-4 space-y-2">
            <div className="flex items-center gap-2">
              <BookOpen className="w-4 h-4 text-red-400" />
              <h4 className="font-semibold text-white text-sm">{curso?.titulo}</h4>
            </div>
            {curso?.categoria_nome && (
              <p className="text-slate-400 text-xs">
                Categoria: <span className="text-red-400">{curso.categoria_nome}</span>
              </p>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-slate-700 space-y-3">
          <Button
            onClick={onConfirmarDesmatricula}
            disabled={carregandoDesmatricula}
            className="w-full bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white font-medium py-3 text-sm transition-all duration-200"
          >
            {carregandoDesmatricula ? (
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                <span>Desmatriculando...</span>
              </div>
            ) : (
              <div className="flex items-center gap-2">
                <AlertTriangle className="w-4 h-4" />
                <span>Confirmar Desmatrícula</span>
              </div>
            )}
          </Button>
          
          <Button
            onClick={onClose}
            variant="ghost"
            className="w-full text-slate-400 hover:text-white hover:bg-slate-800/50 text-sm"
          >
            Cancelar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalDesmatricula; 